(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Serviceformdocs', Serviceformdocs);

    Serviceformdocs.$inject = ['$resource'];

    function Serviceformdocs ($resource) {
        var resourceUrl =  'api/serviceformdocs/:id/:serviceid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
